import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber mucho de matemáticas?',
    a: 'No, el método simplifica todo a fórmulas básicas que cualquier persona puede aplicar en segundos.'
  }, {
    q: '¿Cuánto capital necesito para empezar?',
    a: "Puedes empezar con cualquier cantidad, lo importante es la gestión por 'unidades' que te enseñamos."
  }, {
    q: '¿Sirve para todas las ligas?',
    a: 'Sí, especialmente para ligas de fútbol en Latinoamérica, México, Europa y USA.'
  }, {
    q: '¿Es un grupo de señales?',
    a: 'No. Es un libro que te enseña a NO necesitar grupos de señales nunca más.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <h2 className="text-3xl md:text-4xl text-center text-brand-text mb-12" data-id="element-113">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-114">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-115" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-card border border-brand-gold/10 rounded-lg overflow-hidden transition-all duration-200" data-id="element-116">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-117">
        <span className="font-heading text-xl text-brand-text" data-id="element-118">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-119" />
      </button>

      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-120">
        <p className="text-brand-muted text-lg" data-id="element-121">{answer}</p>
      </div>
    </div>;
}